export default {
  existe(usuario) {
    let existe = $cookies.isKey(usuario);
    if (existe) return true;
    return false;
  },
  criarCookie() {
    //$cookies.set("usuario", "nac9502", "1d", "/");
     //$cookies.set("usuario", "msc17090", "1d", "/");
  },
  getCookie(nomeCookie) {
    if ($cookies.isKey(nomeCookie)) {
      return $cookies.get(nomeCookie);
    } else {
      return "";
    }
  }
};
